module.exports = __webpack_public_path__ + "img/ic-menu-reward.webp";